"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDataFilterIntl = void 0;
var R = __importStar(require("../../utils/ramda"));
var createDataFilterIntl = function (intl) {
  var _a;
  var formatMessage = (_a = intl === null || intl === void 0 ? void 0 : intl.formatMessage) !== null && _a !== void 0 ? _a : R.prop("defaultMessage");
  return {
    applyButton: formatMessage({
      id: "VSX.DataFilter.applyButton",
      defaultMessage: "Apply"
    }),
    resetButton: formatMessage({
      id: "VSX.DataFilter.resetButton",
      defaultMessage: "Reset"
    }),
    selectAll: formatMessage({
      id: "global.button.selectall",
      defaultMessage: "Select All"
    }),
    selectVisible: formatMessage({
      id: "global.button.selectvisible",
      defaultMessage: "Select Visible"
    }),
    deselectAll: formatMessage({
      id: "global.button.deselectall",
      defaultMessage: "De-Select All"
    }),
    deselectVisible: formatMessage({
      id: "global.button.deselectvisible",
      defaultMessage: "De-Select Visible"
    }),
    filters: formatMessage({
      id: "VSX.DataFilter.filters",
      defaultMessage: "Filters"
    }),
    activeFilter: formatMessage({
      id: "VSX.DataFilter.activeFilter",
      defaultMessage: "Active Filter"
    }),
    activeFilters: formatMessage({
      id: "VSX.DataFilter.activeFilters",
      defaultMessage: "Active Filters"
    }),
    unappliedChanges: formatMessage({
      id: "VSX.DataFilter.unappliedChanges",
      defaultMessage: "Some filters have unapplied changes"
    }),
    hasAllOf: formatMessage({
      id: "VSX.DataFilter.hasAllOf",
      defaultMessage: "Has all of"
    }),
    and: formatMessage({
      id: "VSX.DataFilter.and",
      defaultMessage: "AND"
    }),
    hasNoneOf: formatMessage({
      id: "VSX.DataFilter.hasNoneOf",
      defaultMessage: "Has none of"
    }),
    include: formatMessage({
      id: "VSX.DataFilter.include",
      defaultMessage: "Include"
    }),
    exclude: formatMessage({
      id: "VSX.DataFilter.exclude",
      defaultMessage: "Exclude"
    }),
    filterStatusUnsaved: formatMessage({
      id: "VSX.DataFilter.filterStatusUnsaved",
      defaultMessage: "This filter's configuration has not been applied."
    }),
    filterStatusModified: formatMessage({
      id: "VSX.DataFilter.filterStatusModified",
      defaultMessage: "This filter's configuration has been modified."
    })
  };
};
exports.createDataFilterIntl = createDataFilterIntl;